/** These project designations remain valid in Project Team, but not Performance Lens. */
export function isOutsidePerformanceLens(designationCode: unknown): boolean {
  const code = String(designationCode ?? "").trim().toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_").replace(/^_|_$/g, "");
  return code === "PROGRAM_MANAGER" || code.startsWith("PROGRAM_MANAGER_")
    || code === "PRINCIPAL_SPONSOR" || code.startsWith("PRINCIPAL_SPONSOR_");
}
